import React from 'react';
import { useIntl } from 'react-intl';
import { staticConfig } from '../../../config/static';

import styles from '../HeaderMenuButton/headermenu.module.scss';

const { heading, menuStyle } = styles;

export const ProfileSidebar = (): JSX.Element => {
    const { formatMessage } = useIntl();
    const classicLogonPlace = localStorage.getItem('classicLogonPlace');
    const classicMailboxLink = staticConfig?.classicMailboxLink?.replace('{domainType}', classicLogonPlace);
    const classicLink = classicMailboxLink?.replace('/mailbox', '');

    return (
        <nav>
            <ul className={menuStyle}>
                {/* <li className={listHeader}>
                    <a href={`${classicLink}/settings/profile`}>{formatMessage({ id: 'SETTINGS' })}</a>
                </li> */}
                <li className={heading}>{formatMessage({ id: 'SETTINGS' })}</li>
                <li>
                    <a href={`${classicLink}/settings/profile`}>
                        {formatMessage({ id: 'TEXT_SETTINGS_PROFILE_CLASSIC' })}
                    </a>
                </li>
                <li>
                    <a
                        href="/settings/profile"
                        style={{ backgroundColor: '#fff', fontWeight: 'bold', marginTop: '2px' }}
                    >
                        {formatMessage({ id: 'TEXT_SETTINGS_PROFILE_NGDP' })}
                    </a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/rules`}>{formatMessage({ id: 'ARCHIVING_RULES' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/notifications/exceptionlist`}>
                        {formatMessage({ id: 'NEW_MAIL_NOTIFICATION' })}
                    </a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/receiptrules`}>{formatMessage({ id: 'OPENING_RECEIPTS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/mobileaccess`}>{formatMessage({ id: 'MOBILE_ACCESS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/sharedfolders`}>{formatMessage({ id: 'MENU_SHARED_FOLDERS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/cancel`}>{formatMessage({ id: 'CANCEL_EBOKS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/publicmailsdeleteduplicates`}>
                        {formatMessage({ id: 'MANAGE_PUBLIC_MAIL' })}
                    </a>
                </li>
            </ul>
        </nav>
    );
};
